import { Badge } from 'antd';

import { IVehicle } from '../../schema/Vehicle.ts';
import {
  getAlertLifecycleColors,
  getGeographyDistanceColors,
  getMissionLifecycleColors,
} from '../../utils/utils.ts';

interface Props {
  onClick: () => void;
  count: number;
}

export function NotificationBadge(props: Readonly<Props>) {
  return (
    <Badge count={props.count} className={'ariane'} onClick={props.onClick}>
      <img src={'/theme/media/warning.svg'} height="30" alt="notification icon" />
    </Badge>
  );
}

export function MissionLifecycleBadge(props: Readonly<{ lifecycle: string }>) {
  return (
    <span className={'custom-badge rounded-4'} style={getMissionLifecycleColors(props.lifecycle)}>
      {props.lifecycle}
    </span>
  );
}

export function GeographyDistanceBadge(props: Readonly<{ distance: number }>) {
  return (
    <span className={'custom-badge rounded-4'} style={getGeographyDistanceColors(props.distance)}>
      {props.distance} m
    </span>
  );
}

export function AlertLifecycleBadge(props: Readonly<{ lifecycle: string }>) {
  return (
    <span className={'custom-badge rounded-4'} style={getAlertLifecycleColors(props.lifecycle)}>
      {props.lifecycle}
    </span>
  );
}

export function VehicleBadge(props: Readonly<{ vehicle: IVehicle }>) {
  const size = 12;
  const color = props.vehicle?.is_online ? '#7DDE86' : '#C3C4C9';
  return (
    <Badge
      color={color}
      styles={{
        indicator: {
          width: size,
          height: size,
          borderRadius: '50%',
        },
      }}
    />
  );
}
